module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback0-4920e4d8d3d50a6c25d6d83a95a7672e.jpg";